import React from "react";

const Terms = () => {
  return (
    <div style={{ padding: "80px 20px", maxWidth: "900px", margin: "auto", lineHeight: "1.7" }}>
      <h1>Terms & Conditions</h1>

      <p>
        Welcome to UPIN Trading Corporation. By accessing or using this website,
        you agree to comply with and be bound by the following terms and conditions.
      </p>

      <h3>1. Business Purpose</h3>
      <p>
        This website is intended for providing information about our import and export
        services, seafood products, and business communication.
      </p>

      <h3>2. Use of Website</h3>
      <p>
        You agree to use this website only for lawful purposes. Any misuse,
        unauthorized access, or attempt to harm the website or its users is strictly prohibited.
      </p>

      <h3>3. Product Information</h3>
      <p>
        We strive to provide accurate product and service information.
        However, we do not guarantee that all information is always up to date or error-free.
      </p>

      <h3>4. Limitation of Liability</h3>
      <p>
        UPIN Trading Corporation shall not be held responsible for any direct,
        indirect, or incidental damages arising from the use of this website.
      </p>

      <h3>5. External Links</h3>
      <p>
        Our website may contain links to external platforms such as WhatsApp.
        We are not responsible for the content or privacy practices of those platforms.
      </p>

      <h3>6. Changes to Terms</h3>
      <p>
        We may update these Terms & Conditions at any time without prior notice.
        Continued use of the website means you accept those changes.
      </p>

      <h3>7. Contact Information</h3>
      <p>
        If you have any questions regarding these terms, please contact us:
        <br />
        📧 Email: sakethpabbathi@gmail.com
        <br />
        📞 Phone: +91 93477 19244
      </p>

      <p style={{ marginTop: "30px", fontSize: "14px", opacity: 0.7 }}>
        © 2026 UPIN Trading Corporation. All Rights Reserved.
      </p>
    </div>
  );
};

export default Terms;